<template>
  <div class="list">
    
  </div>

</template>

<script>
// import API from '@/api'
export default {

}
</script>

<style lang="scss" scoped>

</style>
